import { Typography } from "@mui/material";
import * as TfmButton from "components/core/TfmButton";
import * as DecisionBaseModal from "components/pages/game/decision-modals/DecisionBaseModal";
import * as FundTapModal from "components/pages/game/decision-modals/FundTapModal";
import * as GameCard from "components/pages/game/GameCard";
import { CardType } from "models/CardType";
import { TapOptionType } from "models/TapOptionType";
import React, { useState } from "react";

export interface Props {
  card: CardType;
  isOpen: boolean;
  onClose: () => void;
  DecisionId?: string;
}

export const Component: React.FC<Props> = ({ card, isOpen, onClose, DecisionId }) => {
  const [selectedTapOption, setSelectedTapOption] = useState<TapOptionType | null>(
    card.tapOptions.length === 1 ? card.tapOptions[0] : null,
  );

  const renderContent = () => {
    return (
      <div>
        <Typography variant="body1">
          Confirm you want to tap <strong>{card.name}</strong>.
        </Typography>
      </div>
    );
  };

  const renderTapOptionButtons = () => {
    return (
      <div>
        <Typography variant="body1">Select an effect to apply when tapping the card.</Typography>
        {card.tapOptions.map((tapOption) => (
          <div key={tapOption.tapOption}>
            <TfmButton.Component
              onClick={() => setSelectedTapOption(tapOption)}
              text={tapOption.description}
              styles={{
                borderColor: "#007BFF",
                backgroundColor: "#007BFF",
                color: "#fff",
                ":hover": {
                  backgroundColor: "#0066CC",
                },
              }}
            />
          </div>
        ))}
      </div>
    );
  };

  const renderConfirmationModal = (option: TapOptionType) => {
    return (
      <FundTapModal.Component
        tapOption={option}
        costsMoney={option.costsMoney ?? false}
        content={
          <div>
            {renderContent()}
            <div>
              <Typography variant="body1">
                Effect Selected: <strong>{option.description}</strong>
              </Typography>
            </div>
            <GameCard.Component name={card.name} tooltip={card.tooltip} />
          </div>
        }
        isOpen={isOpen}
        onClose={() => onClose()}
        card={card}
        DecisionId={DecisionId ?? "MAIN_ACTION"}
      />
    );
  };

  const renderTapOptionsModal = () => {
    return (
      <DecisionBaseModal.Component
        content={
          <div>
            {renderContent()}
            {renderTapOptionButtons()}
            <GameCard.Component name={card.name} tooltip={card.tooltip} />
          </div>
        }
        isOpen={isOpen}
        onClose={() => onClose()}
        ActionData={{
          card: card.name,
          tapOption: selectedTapOption?.tapOption,
        }}
        ActionId="TAP_CARD"
        DecisionId={DecisionId ?? "MAIN_ACTION"}
      />
    );
  };

  return selectedTapOption === null
    ? renderTapOptionsModal()
    : renderConfirmationModal(selectedTapOption);
};

Component.displayName = "TapCardModal";
